import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { REGISTRATION_SLICE } from 'store/constants'
import {
  secureSetItem,
  secureGetItem,
  secureRemoveItem
} from 'utils/secureStorage'
import { UserType, RegistrationState, VerifyIdentityContent } from './types'

const STORAGE_KEY = 'verifiedData'

const loadState = (): RegistrationState => {
  try {
    const stored = secureGetItem(STORAGE_KEY)
    if (stored) return JSON.parse(stored)
  } catch {
    /* ignore */
  }
  return {
    userType: UserType.BUYER,
    phoneNumber: '',
    verifiedData: null
  }
}

const saveState = (state: RegistrationState) => {
  try {
    secureSetItem(STORAGE_KEY, JSON.stringify(state))
  } catch {
    /* ignore */
  }
}

const clearState = () => {
  try {
    secureRemoveItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
}

const defaultState: RegistrationState = {
  userType: UserType.BUYER,
  phoneNumber: '',
  verifiedData: null
}

const registrationSlice = createSlice({
  name: REGISTRATION_SLICE,
  initialState: loadState(),
  reducers: {
    setUserType: (state, action: PayloadAction<UserType>) => {
      const next = { ...state, userType: action.payload }
      saveState(next)
      return next
    },
    setPhoneNumber: (state, action: PayloadAction<string>) => {
      const next = { ...state, phoneNumber: action.payload }
      saveState(next)
      return next
    },
    setVerifiedData: (
      state,
      action: PayloadAction<VerifyIdentityContent | null>
    ) => {
      const next = { ...state, verifiedData: action.payload }
      saveState(next)
      return next
    },
    resetRegistration: () => {
      clearState()
      return defaultState
    }
  },
  selectors: {
    selectUserType: (state) => state.userType,
    selectPhoneNumber: (state) => state.phoneNumber,
    selectVerifiedData: (state) => state.verifiedData
  }
})

export const {
  setUserType,
  setPhoneNumber,
  setVerifiedData,
  resetRegistration
} = registrationSlice.actions
export const { selectUserType, selectPhoneNumber, selectVerifiedData } =
  registrationSlice.selectors
export default registrationSlice
